import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import Cookies from 'js-cookie';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Box, useBreakpoint, useNotification, NotificationBar, InfoFilled } from '@landr/maestro';
import { i18n } from '@lingui/core';
import { RichText } from 'prismic-reactjs';
import { openWebAppLink, openGuestSiteLink } from '@landr/core';
import { usePricingContext } from '../../contexts/PricingProvider/PricingContext.es.js';
import { useCatalogSale } from '../../hooks/useCatalogSale.es.js';
import { EventIds } from '../../constants/EventIds.es.js';

var _templateObject;
var CookiesKeys = /*#__PURE__*/function (CookiesKeys) {
  CookiesKeys["SaleBarDismissedSuffix"] = "_dismissed";
  return CookiesKeys;
}({});
var StyledRichTextContainer = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    p {\n        margin: 0;\n    }\n"])));
var SaleBar = function SaleBar(_ref) {
  var _sale$prismicHelloBar5, _sale$prismicHelloBar6;
  var _ref$isAuthenticated = _ref.isAuthenticated,
    isAuthenticated = _ref$isAuthenticated === void 0 ? true : _ref$isAuthenticated;
  var isMobile = useBreakpoint('md');
  var _useNotification = useNotification(),
    notify = _useNotification.notify;
  var _usePricingContext = usePricingContext(),
    log = _usePricingContext.log,
    env = _usePricingContext.env,
    language = _usePricingContext.language;
  var _useCatalogSale = useCatalogSale({
      includePrismicContent: true,
      language: language
    }),
    sale = _useCatalogSale.data,
    isSaleLoading = _useCatalogSale.loading;
  var isSaleBarDismissedCookiePresent = useMemo(function () {
    var cookie = Cookies.get("".concat(sale === null || sale === void 0 ? void 0 : sale.name).concat(CookiesKeys.SaleBarDismissedSuffix));
    if (cookie) {
      return JSON.parse(cookie);
    }
    return false;
  }, [sale]);
  var _useState = useState(isSaleBarDismissedCookiePresent),
    _useState2 = _slicedToArray(_useState, 2),
    isSaleBarDismissed = _useState2[0],
    setIsSaleBarDismissed = _useState2[1];
  var handleGoToPricing = function handleGoToPricing() {
    if (!sale) {
      return;
    }
    try {
      var _URL, _sale$prismicHelloBar, _sale$prismicHelloBar2;
      var pathname = (_URL = new URL((_sale$prismicHelloBar = sale.prismicHelloBar) === null || _sale$prismicHelloBar === void 0 ? void 0 : (_sale$prismicHelloBar2 = _sale$prismicHelloBar.ctaUrl) === null || _sale$prismicHelloBar2 === void 0 ? void 0 : _sale$prismicHelloBar2.url)) === null || _URL === void 0 ? void 0 : _URL.pathname;
      isAuthenticated ? openWebAppLink(env, pathname.replace('/en', '')) : openGuestSiteLink(env, pathname.replace('/en', ''));
    } catch (error) {
      var _sale$prismicHelloBar3, _sale$prismicHelloBar4;
      log.error('Failed to redirect to pricing page', EventIds.PricingRedirectionError, error, {
        url: (_sale$prismicHelloBar3 = sale.prismicHelloBar) === null || _sale$prismicHelloBar3 === void 0 ? void 0 : (_sale$prismicHelloBar4 = _sale$prismicHelloBar3.ctaUrl) === null || _sale$prismicHelloBar4 === void 0 ? void 0 : _sale$prismicHelloBar4.url
      });
      notify({
        variant: 'danger',
        content: i18n._(
        /*i18n*/
        {
          id: "oL+4VV"
        })
      });
    }
  };
  var handleOnDismiss = function handleOnDismiss() {
    if (!sale) {
      return;
    }
    var cookieValue = JSON.stringify(true);
    Cookies.set("".concat(sale === null || sale === void 0 ? void 0 : sale.name).concat(CookiesKeys.SaleBarDismissedSuffix), cookieValue, {
      secure: true,
      domain: '.landr.com',
      expires: new Date(sale.endDate)
    });
    setIsSaleBarDismissed(cookieValue);
  };
  if (isSaleLoading || !sale || !sale.showHelloBar || isSaleBarDismissed || isSaleBarDismissedCookiePresent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NotificationBar, {
    variant: "informational",
    action: {
      onClick: handleGoToPricing,
      children: RichText.asText((_sale$prismicHelloBar5 = sale.prismicHelloBar) === null || _sale$prismicHelloBar5 === void 0 ? void 0 : _sale$prismicHelloBar5.ctaText),
      isFull: isMobile,
      isRounded: true
    },
    icon: InfoFilled,
    dismissLabel: i18n._(i18n._(
    /*i18n*/
    {
      id: "yz7wBu"
    })),
    onDismiss: handleOnDismiss
  }, /*#__PURE__*/React.createElement(StyledRichTextContainer, null, /*#__PURE__*/React.createElement(RichText, {
    render: (_sale$prismicHelloBar6 = sale.prismicHelloBar) === null || _sale$prismicHelloBar6 === void 0 ? void 0 : _sale$prismicHelloBar6.title
  }))));
};

export { CookiesKeys, SaleBar };
